export const CSS_GEMERATOR_STYLE_TAG_ID = 'ws-generated-atomic-styles';
